import React from "react";
import { SDLCMetadataConstants } from "@sscs/types";
import { Checkbox, IconButton, InputAdornment, List, Menu, Select, } from "@sscs/ui";
import { CloseIcon } from "@sscs/ui/icons";
import styles from "./verifiedFilter.module.scss";
const VerifiedFilter = ({ id, allItemsLabel, value, onChange, onClear, className = "", }) => {
    return (React.createElement(Select, { multiple: true, displayEmpty: true, shrinkLabel: true, id: id, labelId: `${id}-label`, label: "Filter by verified matches", value: value, renderValue: (value) => {
            if (Array.isArray(value)) {
                if (value.length === 0) {
                    return allItemsLabel;
                }
                return value.join(", ");
            }
            else {
                return undefined;
            }
        }, onChange: (value) => onChange(value), endAdornment: value.length > 0 ? (React.createElement(InputAdornment, { position: "end" },
            React.createElement(IconButton, { className: styles["close-icon"], size: "small", onClick: onClear },
                React.createElement(CloseIcon, null)))) : undefined, classes: { select: styles.select }, className: className }, SDLCMetadataConstants.identityVerification.map((option) => (React.createElement(Menu.Item, { key: option, value: option },
        React.createElement(Checkbox, { checked: value.includes(option) }),
        React.createElement(List.ItemText, { primary: option }))))));
};
export default VerifiedFilter;
//# sourceMappingURL=VerifiedFilter.js.map